//

// routes
import { QueryClient, QueryClientProvider, setLogger } from 'react-query'
import axios from 'axios'
import GoogleAnalytics from './components/GoogleAnalytics'
import LoadingScreen from './components/LoadingScreen'
import NotistackProvider from './components/NotistackProvider'
import ChatbotMainWidget from 'src/components/chatbot/components/ChatbotMainWidget'

// components
// hooks
import useAuth from './hooks/useAuth'
import Router from './routes'
// theme
import ThemeConfig from './theme'
import { enableMapSet } from 'immer'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

enableMapSet()

// A request cancelled on purpose (a newer query replaced it, or its view
// unmounted) is not an error: React Query's default logger would print it as one.
/* eslint-disable no-console */
setLogger({
  log: console.log,
  warn: console.warn,
  error: (err) => {
    if (axios.isCancel(err)) return
    console.error(err)
  },
})
/* eslint-enable no-console */

// ----------------------------------------------------------------------

export default function App() {
  const { isInitialized } = useAuth()

  return (
    <ThemeConfig>
      <NotistackProvider>
        {/* Light/dark mode now lives in the account menu (layouts/dashboard/AccountPopover). */}
        {/* <GoogleAnalytics /> */}
        <QueryClientProvider client={queryClient}>
          <ChatbotMainWidget />
          {isInitialized ? <Router /> : <LoadingScreen />}
        </QueryClientProvider>
      </NotistackProvider>
    </ThemeConfig>
  )
}
